import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import axios from "axios";
import {loginUrl} from "./../../config";
import {Redirect} from "react-router-dom";
import {Link} from "react-router-dom";
import {withRouter} from "react-router-dom";
import {changeAuthPopUpStatus} from "../../store/actions/reservationActions";
import {connect} from "react-redux";
import {authTogglePopUpStatus, profile, succeedAuth} from "../../store/actions/userActions";
import {showToast} from "../../helpers/magic";

class Login extends Component {

    state = {
        login: "",
        password: "",
        isError: false,
        success: false,
        isActive: false,
        errors: [],
        loading: false,
        errorMsg: "",
        fromOtherLink: false,
    };

    componentDidMount() {
        this.setState({
            fromOtherLink: false
        })
        if (this.props.match.path.includes("doctor") || this.props.match.path.includes("premium")) {
            this.setState({
                fromOtherLink: true
            })
        }
    };

    handleSignUpBtn = () => {
        this.props.match.path.includes("doctor") || this.props.match.path.includes("premium") ? this.props.authTogglePopUpStatus(true) : this.props.history.push('register');
    };
    handleInputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };
    handleLogin = (e) => {
        // start loading
        this.setState({
            loading: true,
        });
        // prevent default behavior
        e.preventDefault();
        const form = document.getElementById("login-form");

        //const errorDesc = document.getElementById("error-msg");

        // const reservation = window.localStorage.getItem("reservation");

        axios.post(loginUrl, this.state).then(res => {

            // stop loading
            this.setState({
                loading: false,
            });

            if (res.data.Error.code === 20) {
                // cache user & access token
                localStorage.setItem("access_token", JSON.stringify(res.data.Error.token));
                localStorage.setItem("isActive", JSON.stringify(res.data.Response.is_active));

                form.reset();
                if (this.props.match.path.includes("doctor") || this.props.match.path.includes("premium")) {
                    this.props.changeAuthPopUpStatus(false);
                    this.props.profile();
                    if (this.props.match.path.includes("premium")) {
                        this.props.succeedAuth();
                    }
                    showToast(this.props.translate('you_logged_in_successfully'), "green")
                }
                this.setState({
                    login: "",
                    password: "",
                    success: true
                });
                /* if (reservation) {
                     // window.location.href = "/doctor/" + reservation.doctor_unique_id;
                 }*/
            } else {
                switch (res.data.Error.code) {
               /*     case 27:
                        localStorage.setItem("code", JSON.stringify(res.data.Response.pin));
                        localStorage.setItem("isActive", JSON.stringify(res.data.Response.is_active));
                        localStorage.setItem("access_token", JSON.stringify(res.data.Error.token));
                        this.setState({
                            isActive: true,
                            success: true
                        });
                        break;*/
                    case 23:
                    case 24:
                    case 22:
                        this.setState({
                            isError: true,
                            errorMsg: res.data.Error.desc
                        });
                        break;
                    default:
                        break;
                }
            }
        }).catch(error => {
            console.log(error);
            this.setState({
                loading: true,
            });
        });
    };

    render() {
        if (this.state.success === true) {
            if (!this.props.match.path.includes("doctor") && !this.props.match.path.includes("premium")) {
                return <Redirect to='/'/>
            }
        }

        return (
            <div className="login" id="login">
                <div className="wrap-login100 p-l-50 p-r-50 p-t-120 p-b-50 relative">
                    <a href="/" className="closebtn" hidden={!this.state.fromOtherLink}
                       onClick={(e) => this.props.changeAuthFormStatus(e, "close")}>&times;</a>
                    <form className="login100-form validate-form" onSubmit={this.handleLogin} id="login-form">
                        <a href="/" className="logo-auth" hidden={this.state.fromOtherLink}> <img src="images/logo.png"
                                                                                                  alt="seena logo"/>
                        </a>
                        <span className="login100-form-title p-b-59">
                            {this.props.translate('login')}
                        </span>
                        <span id="error-msg" hidden={this.state.isError === false}>
                                {this.state.errorMsg}
                        </span>
                        <div className="wrap-input100 validate-input">
                            <input id="login" type="text" onChange={this.handleInputChange}
                                   className="form-control input100 curvy-input"
                                   placeholder="email or phone number"/>
                        </div>
                        <div className="wrap-input100 validate-input">
                            <input id="password" onChange={this.handleInputChange} type="password"
                                   className="form-control input100 curvy-input"
                                   placeholder="password"/>
                        </div>
                        <div className="container-login100-form-btn relative">
                            <button type="submit"
                                    className="login100-form-btn btn-block cursor-pointer curvy-input height-45">
                                {this.props.translate("login")}
                            </button>
                            <span id="loading" className="auth-loading"
                                  hidden={this.state.loading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                        </div>
                        <div className="text-center link-area full-width">
                            <div onClick={() => this.handleSignUpBtn()}
                                 className="decoration-none cursor-pointer">{this.props.translate("sign_up_now_ques")}</div>
                            <br/>
                            <div hidden={this.state.fromOtherLink}>
                                <Link to="/forget-password"
                                      className="decoration-none">{this.props.translate("forget_your_password_ques")}</Link>
                            </div>
                            <div hidden={this.state.fromOtherLink}>
                                <Link to="/"><span>{"<- " + this.props.translate("back_to_home")} </span></Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // for show/hide pop up
        authPopUpStatus: state.reservation.authPopUpStatus,
        //for show login or register
        authToggleFormStatus: state.user.authToggleFormStatus,
    }
};


const mapDispatchToProps = (dispatch) => {
    return {
        // for show/hide pop up
        changeAuthPopUpStatus: (status) => dispatch(changeAuthPopUpStatus(status)),
        //for show login or register
        authTogglePopUpStatus: (status) => dispatch(authTogglePopUpStatus(status)),
        // to make sure that user logged on or register successfully
        succeedAuth: () => dispatch(succeedAuth()),

        profile: () => {
            dispatch(profile())
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(withRouter(Login)))
